var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEllipsis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99902 9.5C8.82745 9.5 9.49902 8.82843 9.49902 8C9.49902 7.17157 8.82745 6.5 7.99902 6.5C7.1706 6.5 6.49902 7.17157 6.49902 8C6.49902 8.82843 7.1706 9.5 7.99902 9.5Z",
    fill: "#1422BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.999 9.5C13.8275 9.5 14.499 8.82843 14.499 8C14.499 7.17157 13.8275 6.5 12.999 6.5C12.1706 6.5 11.499 7.17157 11.499 8C11.499 8.82843 12.1706 9.5 12.999 9.5Z",
    fill: "#1422BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99902 9.5C3.82745 9.5 4.49902 8.82843 4.49902 8C4.49902 7.17157 3.82745 6.5 2.99902 6.5C2.1706 6.5 1.49902 7.17157 1.49902 8C1.49902 8.82843 2.1706 9.5 2.99902 9.5Z",
    fill: "#1422BD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsis);
export default __webpack_public_path__ + "static/media/ellipsis.5ad6c399344f23a82cd84b05c4aeb3cc.svg";
export { ForwardRef as ReactComponent };